export default __webpack_public_path__ + "static/media/upload_icon.ac162a0e.svg";